import { useCallback, useMemo, useState } from "react";
import { TWebsiteBuilderCopyableNode, TWebsiteBuilderCopyableNodeType } from "../../nodes/websiteBuilderNode";
import { cloneDeep } from "lodash";
import { websiteBuilderSanitize } from "../../sanitization/websiteBuilderSanitize";

type TWebsiteBuilderClipboardCopy = (copyableNode: TWebsiteBuilderCopyableNode) => void;
type TWebsiteBuilderClipboardPeek = () => TWebsiteBuilderCopyableNode;

export interface IWebsiteBuilderClipboard {
  copyType: TWebsiteBuilderCopyableNodeType;
  copyEmpty: boolean;
  copy: TWebsiteBuilderClipboardCopy;
  peek: TWebsiteBuilderClipboardPeek;
}

export function useWebsiteBuilderClipboard(): IWebsiteBuilderClipboard {
  const [copiedNode, setCopiedNode] = useState<TWebsiteBuilderCopyableNode>(null);

  const copyType: TWebsiteBuilderCopyableNodeType = useMemo(() => {
    return copiedNode?.type;
  }, [copiedNode?.type]);

  const copyEmpty: boolean = useMemo(() => {
    return copiedNode == null;
  }, [copiedNode]);

  const copy: TWebsiteBuilderClipboardCopy = useCallback(copyableNode => {
    setCopiedNode(cloneDeep(copyableNode));
  }, []);

  const peek: TWebsiteBuilderClipboardPeek = useCallback(() => {
    if (copiedNode == null) {
      return null;
    }

    return websiteBuilderSanitize(copiedNode);
  }, [copiedNode]);

  const clipboard: IWebsiteBuilderClipboard = useMemo(() => {
    return {
      copyType,
      copyEmpty,
      copy,
      peek,
    };
  }, [copyType, copyEmpty, copy, peek]);

  return clipboard;
}
